import React from 'react';
import SectionLabel from './SectionLabel';

const forYou = [
    'You are already generating revenue but growth is inconsistent or capped',
    'You are serious about building brand equity, not just social media presence',
    'You want systems, not just someone to post content',
    'You are willing to invest properly in structure that compounds',
    'You operate in hospitality, fashion, beauty, real estate, or premium lifestyle',
    'You are open to strategic direction, not just execution on demand',
    "You want to understand what's wrong before you spend more on marketing",
];

const notForYou = [
    'You are looking for cheap execution or low-cost social media posting',
    'You want volume without strategic intent behind the work',
    'You are not ready to invest properly in growth infrastructure',
    'You want quick results without building the systems that sustain them',
    'You are looking for a vendor to follow instructions, not a strategic partner',
    'Your business is pre-revenue or very early stage',
];

const Who: React.FC = () => (
    <section
        id="who"
        className="relative py-[120px] px-10"
        style={{
            background: 'linear-gradient(158deg, #faf4e8 0%, #f5ecce 38%, #ede0b4 72%, #e8d89e 100%)',
            borderTop: '1px solid rgba(184,154,90,0.18)',
        }}
    >
        {/* Ambient glow */}
        <div
            className="absolute top-0 right-0 pointer-events-none"
            style={{
                width: 400,
                height: 400,
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(184,154,90,0.1) 0%, transparent 70%)',
                transform: 'translate(30%, -30%)',
            }}
        />

        <div className="max-w-[1200px] mx-auto relative z-10">
            <SectionLabel>Selective by Design</SectionLabel>

            <h2
                style={{
                    fontFamily: '"Cormorant Garamond", Georgia, serif',
                    fontSize: 'clamp(34px, 4.5vw, 58px)',
                    fontWeight: 300,
                    lineHeight: 1.1,
                    color: '#1a130a',
                    marginBottom: 10,
                }}
            >
                We are not
                <br />
                <em style={{ fontStyle: 'italic', color: '#b89a5a' }}>for everyone.</em>
            </h2>

            <p
                style={{
                    fontSize: 13,
                    fontWeight: 300,
                    color: '#5a4e38',
                    maxWidth: 580,
                    lineHeight: 2,
                    letterSpacing: '0.02em',
                    marginBottom: 64,
                }}
            >
                HNL works with a small number of serious, established brands at any time.
                That selectivity is how we maintain the depth each engagement deserves.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2" style={{ gap: 22 }}>

                {/* For you — brighter glass panel */}
                <div
                    style={{
                        borderRadius: 4,
                        padding: '48px 44px',
                        background: 'rgba(255,248,225,0.42)',
                        border: '1px solid rgba(184,154,90,0.28)',
                        boxShadow: '0 4px 24px rgba(139,110,50,0.1), inset 0 1px 0 rgba(255,255,255,0.6)',
                        backdropFilter: 'blur(8px)',
                        WebkitBackdropFilter: 'blur(8px)',
                    }}
                >
                    <h3
                        style={{
                            fontFamily: '"Cormorant Garamond", Georgia, serif',
                            fontSize: 28,
                            fontWeight: 400,
                            color: '#1a130a',
                            marginBottom: 28,
                            lineHeight: 1.2,
                        }}
                    >
                        HNL is built for you if —
                    </h3>
                    <ul className="list-none">
                        {forYou.map((item, i) => (
                            <li
                                key={i}
                                className="flex items-start gap-[14px] py-[13px]"
                                style={{
                                    borderBottom: i < forYou.length - 1 ? '1px solid rgba(184,154,90,0.14)' : 'none',
                                    fontSize: 12.5,
                                    fontWeight: 300,
                                    color: '#4a3e2a',
                                    lineHeight: 1.7,
                                    letterSpacing: '0.02em',
                                }}
                            >
                                <span style={{ color: '#b89a5a', fontSize: 11, flexShrink: 0, paddingTop: 2 }}>—</span>
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Not for you — dimmer glass panel */}
                <div
                    style={{
                        borderRadius: 4,
                        padding: '48px 44px',
                        background: 'rgba(240,232,210,0.28)',
                        border: '1px solid rgba(184,154,90,0.14)',
                        boxShadow: '0 4px 24px rgba(139,110,50,0.06), inset 0 1px 0 rgba(255,255,255,0.4)',
                        backdropFilter: 'blur(8px)',
                        WebkitBackdropFilter: 'blur(8px)',
                    }}
                >
                    <h3
                        style={{
                            fontFamily: '"Cormorant Garamond", Georgia, serif',
                            fontSize: 28,
                            fontWeight: 400,
                            color: '#9a8e78',
                            marginBottom: 28,
                            lineHeight: 1.2,
                        }}
                    >
                        HNL is not the right fit if —
                    </h3>
                    <ul className="list-none">
                        {notForYou.map((item, i) => (
                            <li
                                key={i}
                                className="flex items-start gap-[14px] py-[13px]"
                                style={{
                                    borderBottom: i < notForYou.length - 1 ? '1px solid rgba(184,154,90,0.12)' : 'none',
                                    fontSize: 12.5,
                                    fontWeight: 300,
                                    color: '#9a8e78',
                                    lineHeight: 1.7,
                                    letterSpacing: '0.02em',
                                }}
                            >
                                <span style={{ color: '#b89a5a', opacity: 0.35, fontSize: 11, flexShrink: 0, paddingTop: 2 }}>—</span>
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>

            </div>
        </div>
    </section>
);

export default Who;